import Answer from './answer.model'
import Media from './media.model'
import type { Question as QuestionType } from '@/types/question.type'

export default class Question implements QuestionType {
  game = null
  question = {
    que: '',
    message: '',
    scoreForQue: Number(localStorage.getItem('scoreForQue')) || 10,
    timeForQue: Number(localStorage.getItem('timeForQue')) || 30,
    answers: [new Answer()],
    // For matchingPairs type we also support a dedicated left column list named 'questions'
    questions: [] as Array<{ id: number; content: string; media?: Media }>,
    link: null,
    dot_x: null,
    dot_y: null,
    scaleX: null,
    scaleY: null,
    markSrcMedia: new Media(),
    backgroundMedia: new Media(),
    radius: null,
    additionalText: null,
    showtimeForQue: true,
  }
  openMedia = new Media()
  endMedia = new Media()
  type = 'trivia' as TypeQuestion
  setting = {
    allowChangeVote: false,
    slideStartVoting: false,
    playAfterClicking: false,
    showInLoop: false,
    xlImage: null,
  }
  displayRegularUser = false
  categories: { name: string }[] = []
}
